"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApHeaderMenu = exports.ApMenuUser = void 0;
var React = require("react");
var ApMenu_1 = require("../ApMenu");
var ApHeaderBar_styles_1 = require("./ApHeaderBar.styles");
exports.ApMenuUser = function (_a) {
    var initials = _a.initials, children = _a.children;
    return React.createElement(ApMenu_1.ApMenu, { button: React.createElement(ApHeaderBar_styles_1.UserMenuButton, null, initials) }, children);
};
exports.ApHeaderMenu = function (_a) {
    var iconName = _a.iconName, children = _a.children;
    return React.createElement(ApMenu_1.ApMenu, { button: React.createElement(ApHeaderBar_styles_1.ApHeaderBarMenuIconTrigger, { theme: "dark", iconName: iconName }) }, children);
};
//# sourceMappingURL=ApHeaderMenu.js.map